/**
 * @generated SignedSource<<0e419c10b7464c373f6e98098bfc070d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type utilizationMonthlyComponent_viewer$data = {
  readonly insightComponentsData: {
    readonly utilizationMonthly: {
      readonly jan: number | null;
      readonly feb: number | null;
      readonly mar: number | null;
      readonly apr: number | null;
      readonly may: number | null;
      readonly jun: number | null;
      readonly jul: number | null;
      readonly aug: number | null;
      readonly sep: number | null;
      readonly oct: number | null;
      readonly nov: number | null;
      readonly dec: number | null;
      readonly janBillable: number | null;
      readonly febBillable: number | null;
      readonly marBillable: number | null;
      readonly aprBillable: number | null;
      readonly mayBillable: number | null;
      readonly junBillable: number | null;
      readonly julBillable: number | null;
      readonly augBillable: number | null;
      readonly sepBillable: number | null;
      readonly octBillable: number | null;
      readonly novBillable: number | null;
      readonly decBillable: number | null;
      readonly people: ReadonlyArray<{
        readonly id: string;
        readonly profilePictureId: string | null;
        readonly profilePictureDefaultId: number | null;
        readonly firstName: string | null;
        readonly lastName: string | null;
        readonly role: string | null;
        readonly jan: number | null;
        readonly feb: number | null;
        readonly mar: number | null;
        readonly apr: number | null;
        readonly may: number | null;
        readonly jun: number | null;
        readonly jul: number | null;
        readonly aug: number | null;
        readonly sep: number | null;
        readonly oct: number | null;
        readonly nov: number | null;
        readonly dec: number | null;
        readonly janBillable: number | null;
        readonly febBillable: number | null;
        readonly marBillable: number | null;
        readonly aprBillable: number | null;
        readonly mayBillable: number | null;
        readonly junBillable: number | null;
        readonly julBillable: number | null;
        readonly augBillable: number | null;
        readonly sepBillable: number | null;
        readonly octBillable: number | null;
        readonly novBillable: number | null;
        readonly decBillable: number | null;
      } | null> | null;
    } | null;
  } | null;
  readonly " $fragmentType": "utilizationMonthlyComponent_viewer";
};
export type utilizationMonthlyComponent_viewer$key = {
  readonly " $data"?: utilizationMonthlyComponent_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"utilizationMonthlyComponent_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jan",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "feb",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mar",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "apr",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "may",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jun",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "jul",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sep",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oct",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nov",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dec",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "janBillable",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "febBillable",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marBillable",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "aprBillable",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mayBillable",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "junBillable",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "julBillable",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "augBillable",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sepBillable",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "octBillable",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "novBillable",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "decBillable",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "componentId"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "labelIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "personIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "projectStatusesBackend"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "roleIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "selectValue"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "shareKey"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "teamIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "year"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "utilizationMonthlyComponent_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "shareKey",
          "variableName": "shareKey"
        }
      ],
      "concreteType": "InsightComponentsDataType",
      "kind": "LinkedField",
      "name": "insightComponentsData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "componentId",
              "variableName": "componentId"
            },
            {
              "kind": "Variable",
              "name": "labelIds",
              "variableName": "labelIds"
            },
            {
              "kind": "Variable",
              "name": "personIds",
              "variableName": "personIds"
            },
            {
              "kind": "Variable",
              "name": "projectStatusesBackend",
              "variableName": "projectStatusesBackend"
            },
            {
              "kind": "Variable",
              "name": "roleIds",
              "variableName": "roleIds"
            },
            {
              "kind": "Variable",
              "name": "selectValue",
              "variableName": "selectValue"
            },
            {
              "kind": "Variable",
              "name": "teamIds",
              "variableName": "teamIds"
            },
            {
              "kind": "Variable",
              "name": "year",
              "variableName": "year"
            }
          ],
          "concreteType": "UtilizationMonthly",
          "kind": "LinkedField",
          "name": "utilizationMonthly",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            (v3/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/),
            (v6/*: any*/),
            (v7/*: any*/),
            (v8/*: any*/),
            (v9/*: any*/),
            (v10/*: any*/),
            (v11/*: any*/),
            (v12/*: any*/),
            (v13/*: any*/),
            (v14/*: any*/),
            (v15/*: any*/),
            (v16/*: any*/),
            (v17/*: any*/),
            (v18/*: any*/),
            (v19/*: any*/),
            (v20/*: any*/),
            (v21/*: any*/),
            (v22/*: any*/),
            (v23/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "UtilizationPerson",
              "kind": "LinkedField",
              "name": "people",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "profilePictureDefaultId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "firstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "lastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "role",
                  "storageKey": null
                },
                (v0/*: any*/),
                (v1/*: any*/),
                (v2/*: any*/),
                (v3/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                (v6/*: any*/),
                (v7/*: any*/),
                (v8/*: any*/),
                (v9/*: any*/),
                (v10/*: any*/),
                (v11/*: any*/),
                (v12/*: any*/),
                (v13/*: any*/),
                (v14/*: any*/),
                (v15/*: any*/),
                (v16/*: any*/),
                (v17/*: any*/),
                (v18/*: any*/),
                (v19/*: any*/),
                (v20/*: any*/),
                (v21/*: any*/),
                (v22/*: any*/),
                (v23/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "78c94ff02889e21d97e646ea46c77ec8";

export default node;
